import { Klass, u_ } from "@pressmedia/webappbase";
import $ from "jquery";
import moment from "moment";

Object.assign(Klass("WebAppBase").prototype, {
	isReady: false,
	moduleKlass: "TyrellModule",
	now: moment(),
	showLoading() {},
	hideLoading() {},
	
	// [exec関数実行時コールバック]
	onExec() {},
	
	// [onReadyで登録された関数の完了コールバック]
	afterExec() {},
	
	// attach execute callbacks
	_execCallbacks: [],
	onReady(fn) {
		if( u_.isFunction(fn) ) {
			if(this.isReady) {
				fn.call(this);
			} else {
				this._execCallbacks.push(fn);
			}
		}
		return this;
	},
	
	/*----------------
	* exec実行時に最初に発火する関数
	*/
	async loadConfig(opt) {
		u_.isObject(opt) || (opt = {});
		opt.app = this;
		opt.config = this.config;
		
		// 共通設定の取得
		const modulle = Klass.new_(this.moduleKlass, opt);
		return new Promise(resolve => {
			modulle.loadConfig(false, (...args) => resolve(args));
		});
	},
	
	/*----------------
	* アプリケーション実行関数
	*/
	async exec(opt) {
		if( u_.isFunction(opt) ) {
			// 引数に関数が渡された場合はonExecとし、第二引数をoptとする
			this.onExec = opt;
			opt = arguments[1];
		}
		
		const _args = await Promise.all([
			// document ready
			new Promise(resolve => $(() => {
				this.showLoading("exec");
				resolve();
			})),
			
			// load config data
			this.loadConfig(opt)
		]);
		
		const args = Array.isArray(_args[1]) ? _args[1] : [_args[1]];
		
		try {
			// [onExecの実行]
			const __args = await Promise.all([
				u_.isFunction(this.onExec) && this.onExec(...args)
			]);
			args.push(__args[0]);
			
			// -- app is ready. --
			this.isReady = true;
			
			// [onReadyで登録されたコールバックの実行]
			const ___args = await Promise.all( this._execCallbacks.map(fn => fn(...args)) );
			
			___args.forEach(arg => args.push(arg));
			
			// -- document is ready --
			$(document.body).addClass("is-ready");
			
			// [afterExecの実行]
			const ____args = await Promise.all([
				u_.isFunction(this.afterExec) && this.afterExec(...args)
			]);
			
			args.push(____args[0]);
			
		} catch(error) {
			args[0] = error;
		}
		
		// as always
		await Promise.all([this.hideLoading("exec")]);
		
		return !!args[0] ? Promise.reject(args) : args;
	},
	
	
	/************
	*  Utility  *
	************/
	
	/**
	 * ソート関数
	 * @param {Array} arr: ソートするオブジェクト配列
	 * @param {String} arr: ソート対象の要素名
	 * @param {Boolean} flg_desc: ture DESC / false ASC
	 * @returns {Array}
	 */
	sortList(arr, sortKey, flg_desc) {
		if(!arr.length) {
			return arr;
		}
		
		const isDateKey = /^date/.test(sortKey);
		const parseData = isDateKey ? data => moment(data) : data => {
			let rtn;
			if( u_.isNumeric(data, true) ) {
				rtn = parseFloat(data);
			} else {
				rtn = String(data);
			}
			return rtn;
		};
		
		return arr.sort((a, b) => {
			let ret;
			if(a[sortKey] === undefined) {
				ret = 1;
			} else
			if(b[sortKey] === undefined) {
				ret = -1;
			} else {
				ret = 0;
				
				let self, next;
				if(a[sortKey] && typeof a[sortKey] === "object") {
					if( Array.isArray(a[sortKey]) ) {
						self = a[sortKey].length;
						next = b[sortKey].length;
						
					} else {
						const tmp = Object.keys(a[sortKey])[0];
						self = parseData(a[sortKey][tmp]);
						next = parseData(b[sortKey][tmp]);
					}
					
				} else {
					self = parseData(a[sortKey]);
					next = parseData(b[sortKey]);
				}
				
				if(isDateKey) {
					if( !self.isValid() ) {
						if(next.isValid()) {
							ret = 1;
						}
					} else
					if( !next.isValid() ) {
						ret = -1;
					} else
					if( self.isBefore(next) ) {
						ret = -1;
					} else
					if( self.isAfter(next) ) {
						ret = 1;
					}
					
				} else {
					if(self > next) {
						ret = 1;
					} else
					if(self < next) {
						ret = -1;
					}
				}
				
				!!flg_desc && (ret *= -1);
			}
			
			return ret;
		});
	},
	
	/**
	* 自動リンク、クラス付与用関数
	* @param {String} txt: 対象の文字列
	* @returns {String}
	*/
	replaceLinkAndClass(txt) {
		let count = 0;
		
		if(txt) {
			// [link]
			this._reLinkAndClass.link.forEach(re => {
				if( re.literal.test(txt) ) {
					txt = txt.replace(re.literal, re.replace);
					count++;
				}
			});
			
			// [cls]
			if( this._reLinkAndClass.cls.literal.test(txt) ) {
				txt = txt.replace(this._reLinkAndClass.cls.literal, this._reLinkAndClass.cls.replace);
				count++;
			}
			
			if(count) {
				const $div = $("<div/>").html(txt);
				$div.find("a[data-href]").each((i, elm) => {
					let target;
					const $elm = $(elm);
					$elm.dataHref = $elm.data("href");
					$elm.removeAttr("data-href");
					if( (/^(\.|mailto:)/).test($elm.dataHref) && !(/\.pdf$/).test($elm.dataHref) ) {
						target = "_self";
					} else {
						target = "_blank";
					}
					$elm.attr({
						href: $elm.dataHref,
						target: target
					});
					
					!$elm.children().length && $elm.append(
						$("<span/>").text( decodeURIComponent($elm.dataHref) )
					);
				});
				txt = $div.html();
			}
		}
		
		return txt;
	},
	
	_reLinkAndClass: {
		link: [
			{
				literal: /((https?:\/\/|mailto:|\.\.?\/)[^\s　()[\]{}<]+)/gi,
				replace: "<a data-href='$1'></a>"
			},
			{
				literal: /\[([^\]\f\n\r\t\v]+)\]\(<a ([^\f\n\r\t\v>]+)><\/a>\)/gi,
				replace: "<a $2><span>$1</span></a>"
			}
		],
		cls: {
			literal:  /{\.([\w- ]+):\s*(.*?)}/g,
			replace: "<span class='$1'>$2</span>"
		}
	}
});
